const settings = {
  APP_URL: process.env.NODE_ENV !== 'production' ? 'http://localhost:3002' : 'https://app.collegelab.org',
  RECAPTCHA: '6LfPSYgUAAAAAMFJ7himQw09gFsHAILN9U2jqJkF'
}

export default settings;